/* eslint-disable react-hooks/exhaustive-deps */
// React Imports
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// Redux Imports
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources.js";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";

// Component Imports
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import ListContainer from "../../../../components/_utils/CommonListView/ListContainer/index.jsx";
import ListTextWithIcon from "../../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index.js";
import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper/index.js";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import TickerAnimation from "../../../../components/_utils/TickerAnimation/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import {
  addNewLabel,
  ReimburseViewAll,
  removeNewLabel,
} from "../../../../redux/features/accounts/ReimburseAccount/index.js";
import {
  resetToggle,
  setToggle,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import useMultiSelect from "../../../../utils/useMultiSelect.js";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import UseHandleScroll from "../../../../hooks/useHandleScroll.js";
import globalText from "../../../../utils/globalText.js";

const parseDateRangeFromUrl = (dateStr) => {
  if (!dateStr) return { start: "", end: "" };
  const parts = dateStr.split(",");
  const start = parts[0] ? Number(parts[0]) : "";
  const end = parts[1] ? Number(parts[1]) : "";
  return { start: isNaN(start) ? "" : start, end: isNaN(end) ? "" : end };
};

const ReimbursementAccountViewAll = ({
  id,
  remPan,
  panNum,
  type,
  remAccount,
  bankAccNumber,
  flow,
  setOpenBeneAssociate,
  ifscCode,
  remIFSC,
  setModalOpen,
  setTxnPayLoad,
  onAccountSelect,
  popupType,
  openBeneAssociate,
  accActiveInactiveState,
  activeInactivePan,
  activeInactiveFlow,
  activeInactiveIfsc,
  activeInactiveBank,
  setIsalertPopup,
  setFlowSelectedId,
  classifiedFlow = false,
  activeType,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownOptionsList = PaginationConfiguration.paginationOptions;
  const { services } = useSelector((state) => state.refreshToken);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { toggle } = useSelector((state) => state.beneAllVerification);
  const categories = useSelector(
    (state) => state?.sharedResources.categoriesData?.categories,
  );
  const dispatch = useDispatch();
  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(setDirection, lastScrollTop);

  const getStatusColor = (status) => {
    switch (status) {
      case "Require approval":
      case "Pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  // useref
  const dropdownRef = useRef(null);
  const filterRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const approvalStatusSyncedToUrlRef = useRef(false);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const scrollContainerRef = useRef(null);
  const lastElementRef = useRef();

  //usestate
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsList[0],
  });
  const dateFromUrl = parseDateRangeFromUrl(searchParam.get("date"));
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [labelPopupAccounts, setLabelPopupAccounts] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? []
      : searchParam.get("label")?.split(",").filter(Boolean) || [],
  );

  const [showSearchBar, setShowSearchBar] = useState(false);
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat"),
  );
  const [loading, setLoading] = useState(true);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false); // Isolated loader for label popup

  const [currentPage, setCurrentPage] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? 1
      : Number(searchParam.get("pageno")) || GlobalConfiguration.lengthCheckOne,
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : location?.state?.approvalStatus === "approved"
        ? "approved"
        : location?.state?.approvalStatus === "pending"
          ? "pending"
          : searchParam.get("status") || "",
  );

  const [currentCategory, setCurrentCategory] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : searchParam.get("category") || "",
  );
  const [searchUserText, setSearchUserText] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : searchParam.get("search") || "",
  );

  const [startDateFilter, setStartDateFilter] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : dateFromUrl.start,
  );
  const [endDateFilter, setEndDateFilter] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : dateFromUrl.end,
  );
  const [accountNumber, setAccountNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveBank
      : type === "ReimbursementAcc" ||
          type === "activeInactive" ||
          popupType === "associated"
        ? ""
        : type === "confirm_create_account"
          ? bankAccNumber
          : searchParam.get("accountNo") || "",
  );

  const [isIfsc, setIsIfsc] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveIfsc
      : type === "ReimbursementAcc" ||
          type === "activeInactive" ||
          popupType === "associated"
        ? ""
        : type === "confirm_create_account"
          ? ifscCode
          : searchParam.get("ifsc") || "",
  );
  const [panNumber, setPanNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Pan" || activeInactiveFlow === "Existing")
      ? activeInactivePan
      : type === "ReimbursementAcc" ||
          type === "activeInactive" ||
          popupType === "associated"
        ? ""
        : type === "confirm_create_account"
          ? panNum
          : searchParam.get("pan") || "",
  );

  const [isFilterApplied, setIsFilterApplied] = useState(false);

  const [selectedValue, setSelectedValue] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? PaginationConfiguration.paginationSmall
      : searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const [mainData, setMainData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const [pageSize, setPageSize] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? PaginationConfiguration.paginationSmall
      : searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labels, setLabels] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [animateViewAll, setAnimateViewAll] = useState(false);
  const [inputData, setInputData] = useState([]);

  const handleSubmit = (key, value) => {
    if (
      type !== "ReimbursementAcc" &&
      type !== "activeInactive" &&
      type !== "confirm_create_account"
    ) {
      handleSearchParams(key, value);
    }
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    setLabelPopupAccounts([]);

    if (labelActionDispatchedRef.current) {
      fetchData();
      labelActionDispatchedRef.current = false;
      setLabelAccounts([]);
      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
  };
  const handleDataPopup = (data) => {
    onAccountSelect(
      data?.bank_name,
      data?.bank_acc_no,
      data?.ifsc_code,
      data?.id,
      data?.category_ids?.map((x) => x.category_name).join(","),
      data?.category_ids?.map((x) => x.category_id),
      data?.pan_no,
      data?.labels,
    );
    setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountIFSC: data.ifsc_code,
      bankAccountName: data.name,
      bankAccountNo: data.bank_acc_no,
      bankLogo: data.bank_name,
      beneAccountId: data.id,
      pan: data.pan_no,
      labels: data.labels,
    }));
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      const startTs = convertDate(start);
      const endTs = convertDate(end);
      setStartDateFilter(startTs);
      setEndDateFilter(endTs);
      if (type !== "ReimbursementAcc" && type !== "activeInactive") {
        handleSearchParams("date", `${startTs},${endTs}`);
      }
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
      if (type !== "ReimbursementAcc" && type !== "activeInactive") {
        handleSearchParams("date", "");
      }
    }
  };

  const selectableAccounts = accumulatedData
    // ?.filter((item) => item?.approval_status !== "archived")
    ?.map((item) => ({ ...item, id: item?.id }));

  const handleToggle = (newToggleValue) => {
    if (loading) {
      setAnimateViewAll(false);
    } else {
      setAnimateViewAll(true);
    }

    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget?.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });
    }
    dispatch(setToggle(newToggleValue));
  };

  const handleSelect = (value) => {
    setDirection("");
    lastScrollTop.current = GlobalConfiguration.lengthCheckZero;
    handleSubmit("pagesize", value);

    if (
      isLabelClicked &&
      value === PaginationConfiguration.paginationSmall &&
      LabelAccounts?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(LabelAccounts, setLabelAccounts, value, selectableAccounts);
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);

    toggleDropdown();
  };

  const filteredData = accumulatedData;

  const handleSelectAll = () => {
    handleMultiSelectAll(
      LabelAccounts,
      setLabelAccounts,
      selectedValue,
      selectableAccounts,
    );
  };

  const handleLabelAccountSelect = (account) => {
    handleSingleSelect(LabelAccounts, setLabelAccounts, selectedValue, {
      ...account,
      id: account?.id,
    });
  };

  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const handlePagination = (page) => {
    setDirection("");
    lastScrollTop.current = GlobalConfiguration.lengthCheckZero;
    setCurrentPage(page);
    if (type !== "ReimbursementAcc" && type !== "activeInactive") {
      handleSearchParams("pageno", page);
    }
  };

  const handleClearFilters = () => {
    setAnimateViewAll(false);
    const defaultPage = GlobalConfiguration?.lengthCheckOne;
    // const defaultSize = dropdownOptionsList[0];
    setCurrentCategory("");
    setStartDateFilter("");
    setEndDateFilter("");
    setCurrentCategory("");
    setAccountNumber("");
    setShowSearchBar(false);
    setSearchUserText("");
    setIsIfsc("");
    setLabelSearchText([]);
    setisLabelClicked(false);
    setCurrentStatus("");
    setCurrentPage(defaultPage);
    setSearchUserTextDebounce("");
    setPanNumber("");

    // if (type !== "ReimbursementAcc" && type !== "activeInactive") {
    //   navigate(
    //     {
    //       pathname: location.pathname,
    //       search: `?pageno=${defaultPage}&pagesize=${defaultSize}`,
    //     },
    //     { replace: true },
    //   );
    // }
    if (type === "activeInactive" && activeInactiveFlow === "Pan") {
      setPanNumber(activeInactivePan);
    } else if (type === "activeInactive" && activeInactiveFlow === "Bank") {
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    } else if (activeInactiveFlow === "Existing") {
      setPanNumber(activeInactivePan);
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    } else if (type === "confirm_create_account") {
      if (activeType === "Pan") {
        setPanNumber(panNum);
      } else {
        setAccountNumber(bankAccNumber);
        setIsIfsc(ifscCode);
      }
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids[0]?.errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, whichToast = "new") => {
    setLabelPopupLoading(true);

    const recordIds = LabelAccounts.map((acc) => acc?.id || acc);

    // Optimistic UI Update
    setLabels((prev) =>
      Array.from(new Set([...(prev || []), ...labelsToAssign])),
    );
    setAccumulatedData((prev) =>
      prev.map((acc) => {
        if (recordIds.includes(acc.id)) {
          return {
            ...acc,
            labels: [...new Set([...(acc.labels || []), ...labelsToAssign])],
          };
        }
        return acc;
      }),
    );
    setLabelPopupAccounts((prev) =>
      prev.map((acc) => ({
        ...acc,
        labels: [...new Set([...(acc.labels || []), ...labelsToAssign])],
      })),
    );
    setAccumulatedData((prev) =>
      prev.map((acc) => {
        if (recordIds.includes(acc.id)) {
          return {
            ...acc,
            labels: [...new Set([...(acc.labels || []), ...labelsToAssign])],
          };
        }
        return acc;
      }),
    );

    const res = await dispatch(
      addNewLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (addNewLabel?.fulfilled?.match(res)) {
      fetchData(true); // Silent background fetch
      toast.dismiss();

      CommonToast({
        text:
          whichToast === "new"
            ? "New label assigned successfully."
            : "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addNewLabel?.rejected?.match(res)) {
      fetchData(true); // Re-sync with backend on failure
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    setLabelPopupLoading(false);
    return addNewLabel?.fulfilled?.match(res) ? true : false;
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const recordIds = LabelAccounts.map((acc) => acc?.id || acc);

    // Optimistic UI Update
    setAccumulatedData((prev) =>
      prev.map((acc) => {
        if (recordIds.includes(acc.id)) {
          return {
            ...acc,
            labels: (acc.labels || []).filter(
              (l) => !labelsToUnassign.includes(l),
            ),
          };
        }
        return acc;
      }),
    );
    setLabelPopupAccounts((prev) =>
      prev.map((acc) => ({
        ...acc,
        labels: (acc.labels || []).filter((l) => !labelsToUnassign.includes(l)),
      })),
    );

    const res = await dispatch(
      removeNewLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabel?.fulfilled?.match(res)) {
      fetchData(true); // Silent background fetch
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeNewLabel?.rejected?.match(res)) {
      fetchData(true); // Re-sync on failure
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLabelPopupLoading(false);
    return removeNewLabel?.fulfilled?.match(res) ? true : false;
  };

  useEffect(() => {
    if (
      type === "ReimbursementAcc" ||
      approvalStatusSyncedToUrlRef.current ||
      type === "activeInactive"
    ) {
      return;
    }
    const statusFromState = location?.state?.approvalStatus;
    if (statusFromState === "approved" || statusFromState === "pending") {
      handleSearchParams("status", statusFromState);
      approvalStatusSyncedToUrlRef.current = true;
    }
  }, [location?.state?.approvalStatus, type, handleSearchParams]);

  const fetchData2 = async () => {
    let response;
    let data = [];
    setLoadingData(true);
    setAnimateViewAll(false);

    switch (active) {
      case "Category":
        response = await dispatch(
          getAllCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.id,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            return itm.includes(searchUserTextDebounce);
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active]);

  async function fetchData(isSilent = false) {
    if (!isSilent) setLoading(true);
    setAnimateViewAll(false);
    try {
      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        ...(type === "activeInactive" && {
          associate:
            type === "activeInactive" && accActiveInactiveState === "active"
              ? ["pending", "approved"]
              : type === "activeInactive" &&
                  accActiveInactiveState === "inactive"
                ? ["blocked", "archived", "rejected"]
                : undefined,
        }),
      };

      const addParamsBasedOnSelection = () => {
        if (currentStatus !== "all") {
          queryParams.approval_status =
            currentStatus.toLowerCase() === "require approval"
              ? "pending"
              : currentStatus;
        }
        if (currentCategory !== "") {
          queryParams.category = currentCategory;
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          !!startDateFilter &&
          !!endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration.day_in_seconds;
        }

        if (accountNumber !== "" || remAccount) {
          queryParams.bank_account_no = remAccount ? remAccount : accountNumber;
        }

        if (isIfsc !== "" || remIFSC) {
          queryParams.ifsc = remIFSC
            ? remIFSC.toUpperCase()
            : isIfsc.toUpperCase();
        }

        if (panNumber !== "" || remPan) {
          queryParams.pan = remPan
            ? remPan.toUpperCase()
            : panNumber.toUpperCase();
        }

        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (!!LabelSearchText?.length) {
          queryParams.labels = LabelSearchText;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(ReimburseViewAll(queryParams));
      const newData = response?.payload?.reimbursement_accounts || [];
      const lbls = response?.payload?.summary?.available_labels || [];
      setLabels(lbls);
      setMainData(response?.payload);
      setAccumulatedData(newData);

      if (!isSilent) setLoading(false);
    } catch (error) {
      if (!isSilent) setLoading(false);
      console.error(error);
    }
  }

  const onMount = () => {};

  useEffect(() => {
    dispatch(enableSwitcher());

    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    scrollContainerRef?.current?.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }, [toggle, currentPage, accumulatedData]);

  useEffect(() => {
    fetchData();
  }, [
    markerData,
    currentPage,
    currentStatus,
    currentCategory,
    searchUserText,
    startDateFilter,
    endDateFilter,
    accountNumber,
    pageSize,
    LabelSearchText,
    remAccount,
    remIFSC,
    remPan,
    isIfsc,
    panNumber,
    accActiveInactiveState,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    isIfsc,
    currentStatus,
  ]);
  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        (currentStatus !== "all" && !!currentStatus),
    );
  };

  useEffect(() => {
    if (type === "ReimbursementAcc" || type === "activeInactive") {
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
    if (
      type === "activeInactive0" ||
      type === "ReimbursementAcc" ||
      type === "confirm_create_account"
    ) {
      dispatch(resetToggle());
    }
  }, []);

  useEffect(() => {
    if (type === "confirm_create_account") {
      setPanNumber(panNum || "");
      setIsIfsc(ifscCode || "");
      setAccountNumber(bankAccNumber || "");
    }
  }, [panNum, ifscCode, bankAccNumber, type]);

  function getAccountStatus(text) {
    switch (text) {
      case "pending": {
        if (services?.includes("RAAccount") || services?.includes("Admin")) {
          return "Require approval";
        } else {
          return "Pending";
        }
      }
      default:
        return text;
    }
  }
  function getAccountStatusDropdownOptionsImpl() {
    let l = ["approved", "pending", "rejected", "blocked", "archived"];
    if (services?.includes("RAAccount") || services?.includes("Admin")) {
      l[1] = "Require approval";
    }
    return l;
  }

  const getAccountStatusDropdownOptions = useMemo(
    getAccountStatusDropdownOptionsImpl,
    [services],
  );

  return (
    <>
      <div
        className={`bg-primary-bg ${type === "ReimbursementAcc" || type === "activeInactive" || type === "confirm_create_account" ? "h-full" : "h-screen"}  flex flex-col relative overflow-hidden`}
        style={{
          width:
            type === "ReimbursementAcc" ||
            type === "activeInactive" ||
            type === "confirm_create_account"
              ? ""
              : "var(--full-width)",
        }}
      >
        <div
          className={`absolute ${loading && "hidden"} bg-primary-nav ${showInnerSearchBar ? "z-z-index-header" : "z-z-index-dropdown"} shadow-box-shadow-top 
              bottom-bottom-base w-full rounded-none
          `}
        >
          {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
            filteredData?.length > GlobalConfiguration.lengthCheckZero && (
              <>
                <div
                  className={`${
                    showInnerSearchBar &&
                    "opacity-light-opacity bg-PopUp-BackDrop pointer-events-none h-full"
                  }`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    dropdownOptions={dropdownOptions}
                    pageSize={pageSize}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </>
            )}
        </div>

        {isLabelPopupOpen && (
          <div
            onClick={() => {
              setIsLabelPopupOpen(false);
            }}
            className="fixed top-top-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
          >
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated accounts/transactions/schedules."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={labelPopupAccounts}
              onClose={handleClose}
              loading={labelPopupLoading}
              setLoading={setLabelPopupLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
            />
          </div>
        )}
        <div
          className={`Label_top_line_of_div w-full hidden `}
          style={{
            zIndex: "var(--z-index-overlay)",
          }}
        >
          <div>
            <p className="w-width-full font-open-sans text-font-xs text-text-primary">
              Only active (pending & approved) accounts are enabled for
              selection.
            </p>
          </div>
        </div>

        <div
          className={` relative ${type === "ReimbursementAcc" || type === "activeInactive" || type === "confirm_create_account" ? "hidden" : "block"} z-z-index-overlay ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"} `}
        >
          <div>
            <div
              className={`  hidden Qmd:block h-navbar-breadcrumb-height w-full `}
            ></div>
          </div>
        </div>

        <div
          className={`bene_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act w-full relative `}
        >
          <TopNavComponent
            direction={direction}
            topNavCtaBtn1Needed={isLabelClicked}
            topNavCtaBtn1Props={
              isLabelClicked
                ? {
                    btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      const textContent = e.target.textContent.trim();
                      if (textContent === "Clear") {
                        setLabelAccounts([]);
                      }
                      if (textContent === "Cancel") {
                        setisLabelClicked(false);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: showSearchBar,
                    hoverOption: "white",
                  }
                : undefined
            }
            topNavCtaBtn2Needed={isLabelClicked}
            handleBack={
              type === "ReimbursementAcc" ||
              type === "activeInactive" ||
              type === "confirm_create_account"
                ? undefined
                : () => {
                    navigate(GlobalConfiguration?.navigate_back);
                  }
            }
            topNavCtaBtn2Props={
              isLabelClicked
                ? {
                    btnText: "Assign labels",
                    btnType: "button",
                    enabledBgColor: LabelAccounts?.length
                      ? "var(--text-primary)"
                      : "var(--text-disabled)",
                    handleFunction: (e) => {
                      e.stopPropagation();
                      if (LabelAccounts?.length) {
                        setLabelPopupAccounts(
                          accumulatedData
                            ?.filter((t) =>
                              LabelAccounts.some((acc) => acc.id === t.id),
                            )
                            ?.map((t) => ({ ...t, id: t.id })),
                        );
                        setIsLabelPopupOpen(true);
                      }
                    },
                    enabledTextColor: LabelAccounts?.length
                      ? "var(--primary-bg)"
                      : "Var(--text-primary)",
                    isDisabled:
                      isLabelClicked && LabelAccounts?.length ? false : true,
                    hoverOption:
                      isLabelClicked && LabelAccounts?.length
                        ? " white"
                        : "black",
                    inActiveVariantNeeded: true,
                  }
                : undefined
            }
            BottomSubText={
              isLabelClicked
                ? "Select accounts to apply labels. These will be used to generate statistics for the associated reimbursement accounts."
                : undefined
            }
            BottomSubTextVaraint="primary"
            isSelectionView={isLabelClicked && true}
            isToggleNeeded={true}
            toggleProps={
              !isLabelClicked
                ? {
                    state: toggle,
                    title: toggle ? "Grid View" : "List View",
                    isDisabled: showSearchBar,
                    handleClick: () => handleToggle(!toggle),
                  }
                : undefined
            }
            selectionText={`${globalText.ACCOUNTS_SELECTED} : ${LabelAccounts?.length || GlobalConfiguration.lengthCheckZero}`}
            selectionBtnProps={
              isLabelClicked
                ? {
                    btnText: `Select up to ${Number(selectedValue)}`,
                    btnType: "button",
                    enabledBgColor:
                      LabelAccounts?.length === Number(selectedValue)
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",
                    handleFunction: () => {
                      handleSelectAll();
                    },
                    inActiveVariantNeeded: true,

                    enabledTextColor: "var(--text-primary)",
                    isDisabled:
                      loading ||
                      selectableAccounts?.length ===
                        GlobalConfiguration.lengthCheckZero,
                    hoverOption:
                      LabelAccounts?.length === Number(selectedValue)
                        ? "black"
                        : "white",

                    icon:
                      !loading &&
                      LabelAccounts?.length === Number(selectedValue)
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                  }
                : undefined
            }
            assignLabelNeeded={true}
            assignTagNeeded={true}
            assignLabelProps={
              !isLabelClicked
                ? {
                    handleFunction: () => {
                      if (
                        flow === "create" ||
                        type === "ReimbursementAcc" ||
                        type === "activeInactive" ||
                        type === "confirm_create_account"
                      ) {
                        actionRestricted();
                        return;
                      }
                      if (
                        services?.includes("ALabel") &&
                        services?.includes("RLabel")
                      ) {
                        if (showSearchBar) {
                          return;
                        }
                        setisLabelClicked((prev) => {
                          if (prev) {
                            setLabelAccounts([]);
                          }
                          return !prev;
                        });
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ALabel,RLabel",
                          },
                        });
                      }
                    },
                    isDisabled:
                      loading ||
                      showSearchBar ||
                      flow === "create" ||
                      type === "ReimbursementAcc" ||
                      type === "activeInactive" ||
                      type === "confirm_create_account",
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,

                    hoverOption: "white",
                    buttonRef: null,
                    title:
                      "Labels will be used to generate statistics for the associated accounts/transactions/schedules.",
                  }
                : undefined
            }
            filteredSearchProps={{
              isSortDisabled: loading,
              isFilterDisabled: loading,
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search reimbursement account",
              filterPlaceholder:
                "Name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("search", val);
                    setSearchUserText(val);
                  },
                  isDropdown: false,
                  isDisabled: loading,
                },
                {
                  name: "Account number",
                  short_name: "Reimb A/c",
                  isMulti: false,
                  value:
                    type === "confirm_create_account" && bankAccNumber
                      ? bankAccNumber
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Bank" ||
                            activeInactiveFlow === "Existing")
                        ? activeInactiveBank
                        : popupType === "associated"
                          ? remAccount
                          : remAccount !== "" &&
                              type === "ReimbursementAcc" &&
                              flow !== "create"
                            ? remAccount
                            : accountNumber,
                  setValue: (val) => {
                    setAccountNumber(val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("accountNo", val);
                  },
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remAccount ||
                          (remAccount?.length ?? false) ||
                          (type === "confirm_create_account" &&
                            ifscCode &&
                            bankAccNumber)
                        ? true
                        : false,
                  valueType: "string",
                },
                {
                  name: globalText?.IFSC,
                  short_name: "IFSC",
                  isMulti: false,
                  value:
                    type === "confirm_create_account" && ifscCode
                      ? ifscCode
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Bank" ||
                            activeInactiveFlow === "Existing")
                        ? activeInactiveIfsc
                        : popupType === "associated"
                          ? remIFSC
                          : remIFSC !== "" &&
                              type === "ReimbursementAcc" &&
                              flow !== "create"
                            ? remIFSC
                            : isIfsc.toUpperCase(),
                  setValue: (val) => {
                    setIsIfsc(val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("ifsc", val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remIFSC ||
                          (remIFSC?.length ?? false) ||
                          (type === "confirm_create_account" &&
                            ifscCode &&
                            bankAccNumber)
                        ? true
                        : false,
                },
                {
                  name: globalText.PAN_NUMBER,
                  short_name: "PAN",
                  isMulti: false,
                  value:
                    type === "confirm_create_account" && panNum
                      ? panNum
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing")
                        ? activeInactivePan
                        : popupType === "associated"
                          ? remPan
                          : remPan !== "" &&
                              type === "ReimbursementAcc" &&
                              flow !== "create"
                            ? remPan
                            : panNumber.toUpperCase(),
                  setValue: (val) => {
                    setPanNumber(val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("pan", val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Pan" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remPan ||
                          (remPan?.length ?? false) ||
                          (type === "confirm_create_account" && panNum)
                        ? true
                        : false,
                },
                {
                  name: "Category",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  displayValue: displayCategory,
                  setValue: (val) => {
                    const c =
                      categories.filter((x) => x.id === val)[0]?.name ?? "";
                    setDisplayCategory(c);
                    setCurrentCategory(val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("category", val);
                    handleSubmit("dispCat", c);
                  },
                  isDropdown: true,
                  isDisabled: loading ? true : false,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    setLabelSearchText(val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit(
                      "label",
                      Array.isArray(val) ? val.join(",") : val,
                    );
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: loading,
                },
              ],
              filters: [
                {
                  name: "Account status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: currentStatus,
                  dropdownPlaceHolder: "Select status",
                  isDisabled: type === "activeInactive" ? true : false,
                  options: getAccountStatusDropdownOptions,
                  statusPop: true,
                  handleChange: (e) => {
                    setCurrentStatus(e);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setAnimateViewAll(false);
                    handleSubmit("status", e);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    handleDateChange(date);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setAnimateViewAll(false);
                  },
                },
              ],
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                currentStatus !== ""
              ),
              isSearchClearAllDisabled:
                (type === "confirm_create_account" ||
                  type === "activeInactive") &&
                ((isIfsc?.length &&
                  accountNumber.length &&
                  !panNumber.length &&
                  !currentCategory?.length &&
                  !LabelSearchText?.length &&
                  !searchUserText?.length) ||
                  (!isIfsc?.length &&
                    !accountNumber?.length &&
                    panNumber?.length &&
                    !currentCategory?.length &&
                    !LabelSearchText?.length &&
                    !searchUserText?.length))
                  ? true
                  : !(
                      accountNumber?.length ||
                      isIfsc?.length ||
                      panNumber?.length ||
                      currentCategory?.length ||
                      LabelSearchText?.length ||
                      searchUserText?.length ||
                      loading
                    ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loading,
              setLoading: setLoadingData,
              isShowFilter: true,
              loadingData: loadingData,
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
          />
        </div>

        {!toggle ? (
          <div
            tabIndex="0"
            className={`scroll-p-top_md relative ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            }  ${
              type === "ReimbursementAcc" ||
              type === "activeInactive" ||
              type === "confirm_create_account"
                ? " h-full flex flex-col flex-1 overflow-hidden min-h-0"
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-0"
            } ${loading || showInnerSearchBar ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden"}`}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();

                return false;
              }
            }}
          >
            {showInnerSearchBar && (
              <>
                <div className="absolute top-top-base left-left-base h-full w-full-width bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header overflow-hidden"></div>
              </>
            )}
            {loading ? (
              <div className="loader-container flex justify-center items-center h-full w-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <div
                ref={scrollContainerRef}
                onScroll={handleScroll}
                className={`scroll flex flex-col min-h-0 items-center h-full-height overflow-y-auto ${showInnerSearchBar && "overflow-y-hidden pointer-events-none"} w-full`}
                style={{
                  scrollPaddingTop: "var(--padding-md)",
                  scrollPaddingBottom: "var(--padding-md)",
                }}
              >
                <div
                  className={`${!toggle && animateViewAll ? "animate-slide-prev" : ""} standard-card-alignment gap-x-gap-sm gap-y-gap-md`}
                  onAnimationEnd={() => setAnimateViewAll(false)}
                >
                  {accumulatedData?.map((account, index) => {
                    const accountStatus = getAccountStatus(
                      account?.approval_status,
                    );
                    return (
                      <CardContainer
                        hoverHeight={
                          GlobalConfiguration?.reimbursementAccountCardHoverHeight
                        }
                        filterRef={scrollContainerRef}
                        context={account}
                        minHeight={GlobalConfiguration.ReimAccCardMinHeight}
                        isSelected={
                          Array.isArray(LabelAccounts) &&
                          LabelAccounts?.some(
                            (item) => item?.id === account?.id,
                          )
                        }
                        isDisabled={
                          id === account?.id
                            ? true
                            : flow === "create"
                              ? [
                                  "blocked",
                                  "archived",
                                  "rejected",
                                  "pending",
                                ].includes(account?.approval_status)
                              : false
                        }
                        onClickHandler={(e, data) => {
                          if (classifiedFlow) {
                            navigate(
                              `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${account.id}`,
                              {
                                replace: true,
                              },
                            );
                            return;
                          }
                          if (
                            type === "activeInactive" ||
                            type === "confirm_create_account"
                          ) {
                            setIsalertPopup(true);
                            setFlowSelectedId(account?.id);
                            return;
                          }
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (popupType === "associated")
                              setOpenBeneAssociate(false);
                            if (flow === "create") {
                              handleDataPopup(data);
                              setModalOpen(false);
                            } else {
                              if (!isLabelClicked) {
                                navigate(
                                  `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${account.id}`,
                                  {
                                    replace: openBeneAssociate ? true : false,
                                    state: {
                                      isViewAll:
                                        location.pathname.includes("view_all"),
                                    },
                                  },
                                );
                                if (openBeneAssociate) {
                                  setOpenBeneAssociate(false);
                                }
                                if (type === "ReimbursementAcc") {
                                  setOpenBeneAssociate(false);
                                }
                              } else {
                                handleLabelAccountSelect?.(account);
                              }
                            }
                          }
                        }}
                      >
                        <card-body>
                          <TextWithIcon
                            type={"text"}
                            text={account.name}
                            textColor={"var(--text-primary)"}
                            subText={"Account name"}
                            iconComponentArray={[
                              ...(isLabelClicked
                                ? [
                                    {
                                      icon:
                                        Array.isArray(LabelAccounts) &&
                                        LabelAccounts.some(
                                          (acc) => acc.id === account.id,
                                        )
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                                      isDisabled: false,
                                    },
                                  ]
                                : []),
                            ]}
                          />

                          <div className="flex gap-x-gap-sm justify-between items-center">
                            <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                              <p
                                className={`text-font-sm text-text-primary flex-1 truncate font-normal px-mobile-padding-l Qmd:px-padding-sm`}
                              >
                                <TickerAnimation
                                  text={formatAccountNumber(
                                    account.bank_acc_no,
                                  )}
                                />
                              </p>
                              <div className="w-full relative flex px-mobile-padding-l Qmd:px-padding-sm justify-between items-center ">
                                <p
                                  className={`text-font-xs text-text-secondary flex-1 truncate font-normal transform-none`}
                                >
                                  Account number
                                </p>
                              </div>
                            </div>
                            <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                              <div className="Qsmd:w-banklogo-width-sm Qsmd:h-banklogo-height-sm h-banklogo-height-mobile w-banklogo-width-mobile flex-shrink-0">
                                <IfscCodeMapper ifscCode={account?.ifsc_code} />
                              </div>
                            </div>
                          </div>
                        </card-body>
                        <card-hover>
                          <TextWithIcon
                            textCase="capitalize"
                            text={accountStatus}
                            subText={"Account status"}
                            fontWeight={"semibold"}
                            textColor={getStatusColor(accountStatus)}
                          />
                          <TextWithIcon
                            text={account?.labels?.join(", ") || "Not assigned"}
                            iconComponentArray={[
                              {
                                icon: ICONS?.LABEL,
                              },
                            ]}
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                          />
                        </card-hover>
                      </CardContainer>
                    );
                  })}
                </div>
              </div>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full ">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p
                  className={`text-font-sm text-text-primary  items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  {type === "activeInactive" &&
                  accActiveInactiveState === "active"
                    ? "No active reimbursement associated accounts found."
                    : type === "activeInactive" &&
                        accActiveInactiveState === "inactive"
                      ? "No inactive reimbursement associated accounts found."
                      : "No data found."}
                </p>

                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active reimbursement accounts linked to the provided bank under the reimbursement account classification."
                        : "There are no existing inactive reimbursement accounts linked to the provided bank under the reimbursement account classification."}
                    </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active reimbursement accounts linked to the provided PAN under the reimbursement account classification."
                        : "There are no existing inactive reimbursement accounts linked to the provided PAN under the reimbursement account classification."}
                    </p>
                  )
                ) : (
                  (type === "confirm_create_account"
                    ? currentCategory !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied ||
                      (activeType === "Pan"
                        ? accountNumber !== "" || isIfsc !== ""
                        : panNumber !== "")
                    : currentCategory !== "" ||
                      panNumber !== "" ||
                      accountNumber !== "" ||
                      isIfsc !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        ) : (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            className={`h-height-full ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            } ${showInnerSearchBar ? "bg-PopUp-BackDrop" : ""} ${
              type === "ReimbursementAcc" ||
              type === "activeInactive" ||
              type === "confirm_create_account"
                ? " h-full flex flex-col flex-1 overflow-hidden min-h-height-base"
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-height-base"
            } ${loading || showInnerSearchBar ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden"} `}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.keyCode === "83" ||
                event.keyCode === "87" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.stopPropagation();
                event.preventDefault();

                return false;
              }
              event.stopPropagation();
            }}
          >
            {showInnerSearchBar && (
              <>
                <div className="absolute top-top-base left-left-base h-full w-full-width bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header overflow-hidden"></div>
              </>
            )}
            {loading ? (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <>
                <div
                  className="scroll flex flex-col items-center z-z-index-content relative w-full flex-1 h-height-full overflow-y-auto overflow-x-hidden"
                  ref={filterRef}
                  style={{
                    scrollPaddingTop: "var(--padding-md)",
                    scrollPaddingBottom: "var(--padding-md)",
                  }}
                >
                  {/* Move the sliding animation directly down onto this inner row grid */}
                  <div
                    className={`${toggle && animateViewAll ? "animate-slide-next" : ""} standard-list-view-alignment`}
                    onAnimationEnd={() => setAnimateViewAll(false)}
                  >
                    {accumulatedData?.map((item) => {
                      const accountStatus = getAccountStatus(
                        item?.approval_status,
                      );
                      return (
                        <ListContainer
                          hoverHeight={
                            GlobalConfiguration?.reimbursementAccountListHoverHeight
                          }
                          key={item.id}
                          filterRef={filterRef}
                          onClickHandler={(e, data) => {
                            if (classifiedFlow) {
                              navigate(
                                `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${item.id}`,
                                {
                                  replace: true,
                                },
                              );
                              return;
                            }
                            if (
                              type === "activeInactive" ||
                              type === "confirm_create_account"
                            ) {
                              setIsalertPopup(true);
                              setFlowSelectedId(item?.id);
                              return;
                            }
                            if (showInnerSearchBar) {
                              return;
                            } else {
                              if (popupType === "associated")
                                setOpenBeneAssociate(false);
                              if (flow === "create") {
                                handleDataPopup(data);
                                setModalOpen(false);
                              } else {
                                if (!isLabelClicked) {
                                  navigate(
                                    `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${item.id}`,
                                    {
                                      replace: openBeneAssociate ? true : false,
                                      state: {
                                        isViewAll:
                                          location.pathname.includes(
                                            "view_all",
                                          ),
                                      },
                                    },
                                  );
                                  if (type === "ReimbursementAcc") {
                                    setOpenBeneAssociate(false);
                                  }
                                } else {
                                  handleLabelAccountSelect?.(item);
                                }
                              }
                            }
                          }}
                          isSelected={
                            Array.isArray(LabelAccounts) &&
                            LabelAccounts?.some(
                              (account) => account?.id === item?.id,
                            )
                          }
                          isDisabled={
                            id === item?.id
                              ? true
                              : flow === "create"
                                ? [
                                    "blocked",
                                    "archived",
                                    "rejected",
                                    "pending",
                                  ].includes(item?.approval_status)
                                : false
                          }
                          context={item}
                        >
                          <list-body>
                            <div className="w-full flex justify-between pr-padding-sm gap-x-gap-sm py-padding-sm">
                              <div
                                className={`flex flex-col gap-y-gap-sm w-full`}
                              >
                                <div className="w-full flex gap-x-gap-sm">
                                  <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                                    <CommonBankLogo
                                      variant="small"
                                      ifsc={item.ifsc_code}
                                    />
                                  </div>
                                  <p className="text-text-primary text-font-xs flex-1 min-w-standard-account-min-width truncate flex font-normal">
                                    <TickerAnimation
                                      text={standardAccountNumberFormat(
                                        item?.bank_acc_no,
                                        true,
                                      )}
                                    />
                                  </p>
                                  <div className="border-l border-primary-bg"></div>
                                  <div className="flex gap-x-gap-sm justify-end items-center">
                                    <p
                                      style={{
                                        color: getStatusColor(accountStatus),
                                      }}
                                      className={` text-font-xs font-semibol capitalize min-w-standard-approval-status-min-width text-right font-semibold`}
                                    >
                                      {accountStatus}
                                    </p>

                                    <img
                                      style={{
                                        display: isLabelClicked
                                          ? "flex"
                                          : "none",
                                      }}
                                      className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                                      src={
                                        Array.isArray(LabelAccounts) &&
                                        LabelAccounts.some(
                                          (acc) => acc.id === item.id,
                                        )
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                                      }
                                      alt=""
                                    />
                                  </div>
                                </div>
                                <div className="w-full pl-padding-sm  flex justify-between items-center relative">
                                  <p
                                    className={`text-font-xs text-text-primary flex-1 truncate font-normal`}
                                  >
                                    <TickerAnimation text={item?.name} />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </list-body>
                          <list-hover>
                            <ListTextWithIcon
                              type={"text"}
                              text={item?.labels?.join(", ") || "Not assigned "}
                              iconComponentArray={[
                                {
                                  icon: ICONS?.LABEL,
                                },
                              ]}
                            />
                          </list-hover>
                        </ListContainer>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p
                  className={`text-font-sm text-text-primary  items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  {type === "activeInactive" &&
                  accActiveInactiveState === "active"
                    ? "No active reimbursement associated accounts found."
                    : type === "activeInactive" &&
                        accActiveInactiveState === "inactive"
                      ? "No inactive reimbursement associated accounts found."
                      : "No data found."}
                </p>

                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active reimbursement accounts linked to the provided Bank under the reimbursement account classification."
                        : "There are no existing inactive reimbursement accounts linked to the provided bank under the reimbursement account classification."}
                    </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active reimbursement accounts linked to the provided PAN under the reimbursement account classification."
                        : "There are no existing inactive reimbursement accounts linked to the provided PAN under the reimbursement account classification."}
                    </p>
                  )
                ) : (
                  (type === "confirm_create_account"
                    ? currentCategory !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied ||
                      (activeType === "Pan"
                        ? accountNumber !== "" || isIfsc !== ""
                        : panNumber !== "")
                    : currentCategory !== "" ||
                      panNumber !== "" ||
                      accountNumber !== "" ||
                      isIfsc !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        )}

        {isLabelClicked && (
          <div className="flex-shrink-0 Qmd:hidden block"></div>
        )}
      </div>
    </>
  );
};

export default ReimbursementAccountViewAll;
